module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//0_novice.png?v=9ff0e15f";